import { useQuery } from '@tanstack/react-query';
import { CHAT_API } from 'utils/globalApiServices';
import { useSalesAssistStore } from 'features/chatAssist/ChatAssist.store';

const queryFn = async ({ email }) => {
  let email_encoded = toBase64(email);
  const url = `clients/${email_encoded}`;
  const data = await CHAT_API.get(url);
  return data?.data || [];
};

const toBase64 = (str) => {
  const utf8Bytes = new TextEncoder().encode(str);
  let binary = '';
  utf8Bytes.forEach((b) => {
    binary += String.fromCharCode(b);
  });

  return btoa(binary);
};

const useGetClientByEmailQuery = ({ enabled, email }) => {
  const { setClientID, setClientError } = useSalesAssistStore();
  return useQuery({
    queryFn: () => queryFn({ email }),
    queryKey: ['CLIENT_AI_INFO'],
    enabled,
    onSuccess: (response) => {
      setClientID(response?.id);
    },
    onError: () => {
      setClientError();
    },
  });
};

export default useGetClientByEmailQuery;
